import React from 'react';
import { verticalTimeline } from '../styles/verticalTimeline';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../redux-store/hook';

const Timeline = (): JSX.Element => {
  const {
    settings: {
      page: { timeline },
    },
  } = useAppSelector((state) => state.template);

  const location = useLocation();
  const isGeneralContentPage = location.pathname.includes('general-content');
  const isTaskListPage = location.pathname.includes('task-list');
  const isAssessmentPage = location.pathname.includes('assessment');
  const isQuizPage = location.pathname.includes('quiz');
  const classes = verticalTimeline(timeline);

  return (
    <>
      {!(isGeneralContentPage || isTaskListPage || isAssessmentPage || isQuizPage) && (
        <div data-testid="timeline" id="JourneyTimeline" className={classes.verticalgrid}></div>
      )}
    </>
  );
};

export default Timeline;
